<template>
<div class="group__main_auth">
    <div class="group__main_auth__content">
        <router-view />
    </div>
</div>
</template>